import { AutogenModelPartialShipmentManifestDetails, AutogenRowPartialShipmentManifestDetails } from "./autogen/AutogenModelPartialShipmentManifestDetails";

export class ModelPartialShipmentManifestDetails extends AutogenModelPartialShipmentManifestDetails<RowPartialShipmentManifestDetails> {
	constructor() {
		super(RowPartialShipmentManifestDetails);
	}
}

export class RowPartialShipmentManifestDetails extends AutogenRowPartialShipmentManifestDetails {
}